<template>
  <div class="text-field-menu-bar" :class="{ 'text-field-menu-bar--disabled': disabled }">
    <template v-for="(item, index) in items">
      <div v-if="item.type === 'divider'" :key="index" class="text-field-menu-bar__divider" />
      <TextFieldMenuItem
        v-else
        :key="index"
        v-bind="item"
        :disabled="disabled"
        @mousedown="$emit('mousedown', $event)"
      />
    </template>
  </div>
</template>

<script>
/**
 * Menu of the advanced text field.
 * Taken from TipTap documentation https://www.tiptap.dev/examples/collaborative-editing
 * @vue-prop {Object} editor - TipTap Editor
 */
import TextFieldMenuItem from '@/components/text-field/text-field-menu-item.vue'

export default {

  name: 'TextFieldMenuBar',

  components: {
    TextFieldMenuItem,
  },

  props: {
    editor: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
    hideUndoRedo: Boolean,
  },

  data() {
    return {
    }
  },

  computed: {
    items() {
      const items = [
        {
          icon: 'bold',
          title: this.$t('message.BOLD'),
          action: () => this.editor.chain().focus().toggleBold().run(),
          isActive: () => this.editor.isActive('bold'),
        },
        {
          icon: 'italic',
          title: this.$t('message.ITALIC'),
          action: () => this.editor.chain().focus().toggleItalic().run(),
          isActive: () => this.editor.isActive('italic'),
        },
        {
          icon: 'underline',
          title: this.$t('message.UNDERLINE'),
          action: () => this.editor.chain().focus().toggleUnderline().run(),
          isActive: () => this.editor.isActive('underline'),
        },
        {
          icon: 'strikethrough',
          title: this.$t('message.STRIKETHROUGH'),
          action: () => this.editor.chain().focus().toggleStrike().run(),
          isActive: () => this.editor.isActive('strike'),
        },
        // {
        //   icon: 'code-view',
        //   title: 'Code',
        //   action: () => this.editor.chain().focus().toggleCode().run(),
        //   isActive: () => this.editor.isActive('code'),
        // },
        {
          icon: 'mark-pen-line',
          title: this.$t('message.HIGHLIGHT'),
          action: () => this.editor.chain().focus().toggleHighlight().run(),
          isActive: () => this.editor.isActive('highlight'),
        },
        {
          type: 'divider',
        },
        // {
        //   icon: 'h-1',
        //   title: this.$t('message.HEADING_1'),
        //   action: () => this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
        //   isActive: () => this.editor.isActive('heading', { level: 1 }),
        // },
        // {
        //   icon: 'h-2',
        //   title: this.$t('message.HEADING_2'),
        //   action: () => this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
        //   isActive: () => this.editor.isActive('heading', { level: 2 }),
        // },
        // {
        //   icon: 'paragraph',
        //   title: this.$t('message.PARAGRAPH'),
        //   action: () => this.editor.chain().focus().setParagraph().run(),
        //   isActive: () => this.editor.isActive('paragraph'),
        // },
        {
          icon: 'list-unordered',
          title: this.$t('message.BULLET_LIST'),
          action: () => this.editor.chain().focus().toggleBulletList().run(),
          isActive: () => this.editor.isActive('bulletList'),
        },
        {
          icon: 'list-ordered',
          title: this.$t('message.NUMBERED_LIST'),
          action: () => this.editor.chain().focus().toggleOrderedList().run(),
          isActive: () => this.editor.isActive('orderedList'),
        },
        {
          icon: 'list-check-2',
          title: this.$t('message.CHECK_LIST'),
          action: () => this.editor.chain().focus().toggleTaskList().run(),
          isActive: () => this.editor.isActive('taskList'),
        },
        // {
        //   type: 'divider',
        // },
        // {
        //   icon: 'double-quotes-l',
        //   title: this.$t('message.BLOCKQUOTE'),
        //   action: () => this.editor.chain().focus().toggleBlockquote().run(),
        //   isActive: () => this.editor.isActive('blockquote'),
        // },
        // {
        //   icon: 'separator',
        //   title: this.$t('message.HORIZONTAL_LINE'),
        //   action: () => this.editor.chain().focus().setHorizontalRule().run(),
        // },
        // {
        //   type: 'divider',
        // },
        // {
        //   icon: 'text-wrap',
        //   title: 'Hard Break',
        //   action: () => this.editor.chain().focus().setHardBreak().run(),
        // },
        // {
        //   icon: 'format-clear',
        //   title: this.$t('message.CLEAR_FORMATTING'),
        //   action: () => this.editor.chain()
        //     .focus()
        //     .clearNodes()
        //     .unsetAllMarks()
        //     .run(),
        // },
      ];
      if (!this.hideUndoRedo) {
        items.push(...[
          {
            type: 'divider',
          },
          {
            icon: 'arrow-go-back-line',
            title: this.$t('message.UNDO'),
            action: () => this.editor.chain().focus().undo().run(),
          },
          {
            icon: 'arrow-go-forward-line',
            title: this.$t('message.REDO'),
            action: () => this.editor.chain().focus().redo().run(),
          },
        ]);
      }
      if (this.disabled) {
        return items.map(item => ({ ...item, action: () => {} }));
      }
      return items;
    },
  },
};
</script>

<style lang="scss">
.text-field-menu-bar {
  &__divider {
    width: 2px;
    height: 1.25rem;
    background-color: rgba(#000, 0.1);
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
}
</style>
